import { render } from "./ResultsSection.vue?vue&type=template&id=5c9ca27a&scoped=true"
import script from "./ResultsSection.vue?vue&type=script&lang=js"
export * from "./ResultsSection.vue?vue&type=script&lang=js"

import "./ResultsSection.vue?vue&type=style&index=0&id=5c9ca27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9ca27a"]])

export default __exports__